<template>
	<div class="flex flex-wrap">
		<DjCardTag v-for="(tag, index) in vsblTags" :key="index" bordered>
			<span class="whitespace-nowrap">{{ tag }}</span>
		</DjCardTag>
		<DjCardTag v-if="rmnTags.length > 0">
			<BaseTooltip :title="rmnTags.join(' | ')" class="px-2 py-1 bg-dj-gray-minimal rounded-big -mt-2 -mb-2">
				+{{ rmnTags.length }}
			</BaseTooltip>
		</DjCardTag>
	</div>
</template>

<script lang="ts">
import DjCardTag from "~/ui-kit/components/card/partials/DjCardTag.vue";
import BaseTooltip from "~/ui-kit/components/BaseTooltip.vue";

import { computed, defineComponent } from "vue";
import type { TagObject } from "~/ui-kit/types/types";

export default defineComponent({
	name: "DjCardJobTags",
	components: {
		DjCardTag,
		BaseTooltip,
	},
	props: {
		tags: {
			type: Object,
			default: () => {
				return {};
			},
		},
		lang: {
			type: String,
			default: "hu",
		},
		visibleTags: {
			type: Number,
			default: 999,
		},
	},
	setup(props) {
		const allTags = computed(() => {
			const result: string[] = [];

			const tagsRecord = props.tags as Record<string, unknown>;

			Object.values(tagsRecord).forEach((rawTag) => {
				const tag = rawTag as {
					data?: TagObject[];
					name?: Record<string, string>;
				};

				if (Array.isArray(tag.data)) {
					tag.data.forEach((tagObj: TagObject) => {
						Object.entries(tagObj.name).forEach((ele) => {
							if (ele[0] === props.lang) result.push(String(ele[1]));
						});
					});
				} else if (tag.name) {
					Object.entries(tag.name).forEach((ele) => {
						if (ele[0] === props.lang) result.push(String(ele[1]));
					});
				}
			});

			return result;
		});

		const vsblTags = computed(() => allTags.value.slice(0, props.visibleTags));
		const rmnTags = computed(() => allTags.value.slice(props.visibleTags));

		return {
			vsblTags,
			rmnTags,
		};
	},
});
</script>
